var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"border":"","columns":_vm.tableTitle,"data":_vm.tableDetails,"stripe":"","height":"600","loading":_vm.tableDetails.length<1}})}
var staticRenderFns = []

export { render, staticRenderFns }